import React, { FunctionComponent, useEffect } from 'react';
import { FiltersProps } from './types';
import {
  Filter as RaFilter,
  TextInput as RaTextInput,
  useListContext,
} from 'react-admin';
import Input from '../Input';
import DateRangeField from '../BillingDateRangeFilter/BillingDateRangeFilter';

const Filters: FunctionComponent<FiltersProps> = ({
  search,
  filters,
  ...restProps
}) => {
  const { setFilters, filterValues, displayedFilters } = useListContext();

  useEffect(() => {
    if (!filterValues) return;

    const newValues = { ...filterValues };
    let changed = false;

    Object.keys(newValues).forEach((key) => {
      const base = key.replace(/_(start|end)$/, '');
      if (
        (key.endsWith('_start') || key.endsWith('_end')) &&
        !displayedFilters[base]
      ) {
        newValues[key] = undefined;
        changed = true;
      }
    });

    if (changed) {
      setFilters(newValues, displayedFilters);
    }
  }, [displayedFilters, filterValues, setFilters]);

  function renderSearch() {
    if (typeof search === 'undefined' || !search.enabled) {
      return null;
    }

    const label = search?.label || 'resource.search.label';

    return <RaTextInput label={label} source="q" alwaysOn key="search" />;
  }

  function renderFilters() {
    if (typeof filters === 'undefined') {
      return null;
    }

    return [
      renderSearch(),
      ...filters.map((filterProps) => {
        const source = filterProps.source || filterProps.key;

        if (filterProps.type === 'dateRange') {
          return (
            <DateRangeField {...filterProps} source={source} key={source} />
          );
        }

        return <Input {...filterProps} source={source} key={filterProps.key} />;
      }),
    ];
  }

  return <RaFilter {...restProps}>{renderFilters()}</RaFilter>;
};

export default Filters;
